import {
  ColumnsType,
  DefaultRouteTabs,
  EditIcon,
  InfiniteTable,
} from '@/components/_common';
import { Purchase, PurchaseItems } from '@/core/domain/purchase/Purchase.types';
import { PageProps } from '@/types/PageProps';
import { quantityFormatter } from '@/utils/number';
import { Space, Typography } from 'antd';
import { Helmet } from 'react-helmet';
import { FaUnlink } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { getTableScrollX } from '@/utils/table';
function ConfirmImportPurchaseCsvPage({ route }: PageProps) {
  const intl = useIntl().formatMessage;
  const { Title } = Typography;
  const { state } = useLocation<Purchase>();

  const columns: ColumnsType<PurchaseItems> = [
    {
      dataIndex: 'manufacturingCode',
      title: 'Cód. fabricante',
      ellipsis: true,
      width: 140,
    },
    {
      dataIndex: 'name',
      title: 'Descrição',
      ellipsis: true,
      width: 260,
      render: (value) => (
        <>
          <FaUnlink
            style={{ marginRight: 10, display: 'inline-block' }}
            cursor="pointer"
            title="Remover Vinculo"
          />
          {value}
        </>
      ),
    },
    {
      dataIndex: 'workOrderCode',
      title: 'O.S.',
      render: (value) => value ?? '-',
      ellipsis: true,
      width: 140,
    },
    {
      dataIndex: 'quantity',
      title: 'Qtd.',
      render: (value) => quantityFormatter(value),
      ellipsis: true,
      width: 140,
    },
    {
      dataIndex: 'unitaryValue',
      title: 'Pr. Unit. (R$)',
      render: (value) => `R$ ${quantityFormatter(value)}`,
      ellipsis: true,
      width: 140,
    },
    {
      dataIndex: 'discount',
      title: 'Desc.(R$)',
      render: (value) => `R$ ${quantityFormatter(value)}`,
      ellipsis: true,
      width: 140,
    },
    {
      dataIndex: 'totalAmount',
      title: 'Vr. total liquido (R$)',
      render: (value) => `R$ ${quantityFormatter(value)}`,
      ellipsis: true,
      width: 140,
    },
    {
      dataIndex: 'actions',
      title: intl({ id: 'commons.list.header.action' }),
      render: (_, _record) => (
        <Space>
          <EditIcon />
        </Space>
      ),
      ellipsis: true,
      width: 50,
      align: 'right',
      fixed: 'right',
    },
  ];
  return (
    <>
      <Helmet title={'intl({ id: route.name })'} />
      <DefaultRouteTabs route={route.parent}>
        <Title level={3}>Itens da Nota</Title>

        <InfiniteTable
          dataSource={state?.purchaseItems}
          columns={columns}
          rowKey={(row) => row.id}
          scroll={{ x: getTableScrollX(columns) }}
          loading={!!!state.purchaseItems}
        />
      </DefaultRouteTabs>
    </>
  );
}
export default ConfirmImportPurchaseCsvPage;
